<template>
  <div class="text-center navy--text text--lighten-1">
    <a href="#" class="link link-underline">Adveroo</a>
    <span class="mx-2">•</span>
    <a href="#" class="link link-underline">Zásady ochrany osobních údajů</a>
    <span class="mx-2">•</span>
    <a href="#" class="link link-underline">Všeobecné obchodní podmínky</a>
  </div>
</template>

<script>
export default {
  name: "FooterList",
}
</script>
